export default "__VITE_ASSET__DWO4x9IY__"